import React, { useState } from 'react';
import styled from '@emotion/styled';
import { COLOR_GREEN } from 'client/components/MarketingPagesShared/styles';
import { TriangleIcon } from 'screens/AdsByAnchorScreen/components/Carousel/components';
import { PODCAST_AD_TYPES } from '../constants';
import { SCREEN_BREAKPOINTS } from '../../../constants';
import { CarouselNavProps, UPDATE_NEXT_ACTIVE_AD_INDEX } from '../types';

const DesktopNavBar = styled.ul`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding-bottom: 15px;
  border-bottom: 0.5px solid #97e0ce;
  list-style: none;
  padding-inline-start: 0;
  @media (max-width: 600px) {
    display: none;
  }
`;

const CarouselNavBarButton = styled.button<{ isActive?: boolean }>`
  color: ${({ isActive }) => (isActive ? '#E8F524' : '#97E0CE')};
  font-weight: ${({ isActive }) => (isActive ? '900' : 'bold')};
  font-size: 1.8rem;
  line-height: 2.4rem;
  cursor: ${({ isActive }) => (isActive ? 'auto' : 'pointer')};
  &:focus,
  &:hover {
    text-decoration: underline;
  }
  @media (max-width: ${SCREEN_BREAKPOINTS.SMALL_DESKTOP}px) {
    font-size: 1.6rem;
    line-height: 1.8rem;
    text-align: left;
  }
`;

const MobileNavToggleButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 26px;
  padding: 10px 0;
  border-bottom: 1px solid #97e0ce;
  color: #e8f524;
  font-weight: 900;
  font-size: 2rem;
  line-height: 2.4rem;
  text-align: left;
  &:focus,
  &:hover {
    svg {
      fill: none;
    }
  }
  &:focus {
    text-decoration: underline;
  }
  svg {
    width: 10px;
    transform: rotate(-30deg);
  }
`;

const MobileNavMenuContainer = styled.div`
  position: absolute;
  top: 45px;
  z-index: 1;
  display: grid;
  grid-gap: 24px;
  grid-template-columns: 1fr;
  width: 100%;
  padding: 28px 20px;
  font-size: 2rem;
  line-height: 2.4rem;
  background-color: #97e0ce;
`;

const MobileNavButton = styled.button<{ isActive?: boolean }>`
  color: ${({ isActive }) =>
    isActive ? 'rgba(24, 89, 65, 0.25)' : COLOR_GREEN};
  font-weight: ${({ isActive }) => (isActive ? '900' : 'bold')};
  text-align: left;
  &:focus,
  &:hover {
    text-decoration: underline;
  }
`;

const MobileNav = styled.div`
  position: relative;
  display: none;
  @media (max-width: 600px) {
    display: block;
  }
`;

export const CarouselNav = ({
  activeAdIndex,
  setNextActiveAdIndex,
}: CarouselNavProps) => {
  const [showMobileNavOptions, setShowMobileNavOptions] = useState(false);
  const currentSection = PODCAST_AD_TYPES[activeAdIndex].title;
  return (
    <>
      <MobileNav>
        <MobileNavToggleButton
          onClick={() => setShowMobileNavOptions(!showMobileNavOptions)}
          aria-haspopup="true"
          aria-expanded={showMobileNavOptions}
          aria-label={`Show menu to learn more ways to each with Anchor. Currently showing ${currentSection}`}
        >
          {currentSection}
          <TriangleIcon />
        </MobileNavToggleButton>
        {showMobileNavOptions ? (
          <MobileNavMenuContainer role="menu">
            {PODCAST_AD_TYPES.map((ad, index) => (
              <MobileNavButton
                role="menuitem"
                isActive={activeAdIndex === index}
                aria-label={`Show description on how to earn money with ${ad.title}`}
                aria-current={activeAdIndex === index}
                onClick={() => {
                  setNextActiveAdIndex({
                    type: UPDATE_NEXT_ACTIVE_AD_INDEX,
                    value: index,
                  });
                  setShowMobileNavOptions(false);
                }}
              >
                {ad.title}
              </MobileNavButton>
            ))}
          </MobileNavMenuContainer>
        ) : null}
      </MobileNav>
      <DesktopNavBar>
        {PODCAST_AD_TYPES.map((ad, index) => (
          <li key={`carousel-navigation__${ad.title}`}>
            <CarouselNavBarButton
              isActive={activeAdIndex === index}
              aria-label={`Show description on how to earn money with ${ad.title}`}
              aria-current={activeAdIndex === index}
              onClick={() =>
                setNextActiveAdIndex({
                  type: UPDATE_NEXT_ACTIVE_AD_INDEX,
                  value: index,
                })
              }
            >
              {ad.title}
            </CarouselNavBarButton>
          </li>
        ))}
      </DesktopNavBar>
    </>
  );
};
